export default {"src":"/login-app/[GIT_HASH]/_next/static/media/history_toggle_off.5ac9db82.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};